export default "__VITE_ASSET__CsMmA9Hu__"